import { useQuery } from '@tanstack/react-query';
import { format } from 'date-fns';

import { get } from '../../../lib/api';

export const useGetChartData = ({
  filterBy,
  startDate,
  endDate,
  campaignId,
  newAirbo,
  type,
}) => {
  const { data, isLoading } = useQuery(
    ['chartsData', filterBy, startDate, endDate, campaignId, type],
    () => {
      let chartType;
      let requestedSeriesList;

      if (type === 'cumulativeVisits') {
        chartType = 'Charts::CumulativeVisitActivityChart';
        requestedSeriesList = ['cumulative_unique_visits'];
      } else if (type === 'totalVisits') {
        chartType = 'Charts::TotalVisitActivityChart';
        requestedSeriesList = ['total_visit_activity'];
      } else if (campaignId || newAirbo) {
        chartType = 'Charts::CampaignUniqueVisitActivityPostsChart';
        requestedSeriesList = ['unique_visits', 'posts_sent'];
      } else {
        chartType = 'Charts::BoardUniqueLoginActivityDigestsChart';
        requestedSeriesList = ['unique_login_activity', 'digests_sent'];
      }

      return get('/api/client_admin/charts', {
        chart_type: chartType,
        interval_type: filterBy,
        requested_series_list: requestedSeriesList,
        start_date: format(startDate, 'yyyy-MM-dd'),
        end_date: format(endDate, 'yyyy-MM-dd'),
        campaign_id: campaignId,
      });
    },
  );

  return { data, isLoading };
};
